import React, { DragEventHandler, FC, useCallback, useEffect, useMemo } from 'react';
import { AnswerType1, AnswerType4, QuizQuestion } from '../../shared/types';

type Props = {
  data: QuizQuestion;
  isSubmitted: boolean;
  answersState: AnswerType4[];
  setAnswersState: (state: AnswerType4[]) => void;
};

const answerHeaders = ['Шын', 'Жалған', 'Жауап жоқ'];
const answerVariants = ['Иә', 'Жоқ', 'Қате'];

export const CardTemplate16: FC<Props> = ({ data, isSubmitted, answersState, setAnswersState }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, value: string, answIndex: number) => {
    if (e.target.checked) {
      const newState = answersState.map((item, index) => {
        if (index === answIndex) {
          return { ...item, correct: value };
        }
        return item;
      });
      setAnswersState(newState as AnswerType4[]);
    }
  };

  return (
    <div className="text-center tw-px-3 xl:tw-px-[100px]">
      <h5 className="h3 tw-underline">{data.qs_main}</h5>
      <p className="tw-mt-3 tw-text-xl sm:tw-text-2xl">{data.qs_dsc}</p>
      <div className="my-3 my-sm-5 tw-flex tw-flex-col gap-3">
        <div className="row gx-1 gx-sm-2 gy-2 gy-sm-4 tw-items-center">
          <div className="col-6 col-lg-8" />
          <div className="col-6 col-lg-4">
            <div className="row gx-1">
              {answerHeaders.map((item, index) => (
                <div
                  className={`${item === 'Жауап жоқ' ? 'col-5' : item === 'Жалған' ? 'col-4' : 'col-3'} tw-text-sm lg:tw-text-lg tw-border-0 ${index !== 0 ? 'tw-border-l' : ''} tw-border-solid tw-border-black`}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
          {answersState.map((answ, index) => {
            return (
              <>
                <div className="col-6 col-lg-8">
                  <div className="px-2 tw-text-md lg:tw-text-2xl tw-text-left tw-text-[#0c276c]">{answ.value}</div>
                </div>
                <div className="col-6 col-lg-4">
                  <div className="row gx-1">
                    {['yes', 'no', 'other'].map((item, vIdx) => (
                      <div className={item === 'other' ? 'col-5' : item === 'no' ? 'col-4' : 'col-3'}>
                        <React.Fragment key={answ.value + data.id}>
                          <input
                            type="radio"
                            className="btn-check"
                            name="btnradio"
                            id={'cardAnswer-' + answ.value + item}
                            autoComplete="off"
                            onChange={(e) => handleChange(e, item, index)}
                            disabled={isSubmitted}
                          />
                          <label
                            className={
                              `btn !tw-px-1.5 sm:!tw-px-3 rounded-2 !tw-text-sm lg:!tw-text-2xl !tw-h-[34px] lg:!tw-h-[46px] !tw-w-[34px] lg:!tw-w-[46px] !tw-text-[#0c276c] ${!isSubmitted ? 'hover:!tw-scale-[1.1] !tw-transition-all ' : ''} ` +
                              (answ.correct === item
                                ? isSubmitted
                                  ? (data.paramjs as AnswerType1)[`${index + 1}`].correct === item
                                    ? 'btn-success !tw-text-white !tw-opacity-100'
                                    : 'btn-danger !tw-text-white !tw-opacity-100'
                                  : '!tw-bg-[#0c276c] !tw-text-white '
                                : '!tw-bg-gray-100')
                            }
                            htmlFor={'cardAnswer-' + answ.value + item}
                          >
                            {/*{answerVariants[vIdx]}*/}
                          </label>
                        </React.Fragment>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};
